import React from 'react'
// import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

const SEO = ({ description, keywords, title, image, url, author, lang }) => {
    const { site } = useStaticQuery(
        graphql`
            query {
                site {
                    siteMetadata {
                        title
                        description
                        author {
                            name
                        }
                        siteUrl
                        image
                        social {
                            twitter
                        }
                    }
                }
            }
        `
    )

    const metaDescription = description || site.siteMetadata.description
    const metaTitle = title || site.siteMetadata.title
    const metaAuthor = author || site.siteMetadata.author.name
    const metaUrl = url || site.siteMetadata.siteUrl
    const metaImage = image || site.siteMetadata.siteUrl
    const metaKeywords = keywords || [
        'feighmi',
        'feighmi blog',
        'blog',
        'feighmiblog'
    ]

    return (
        <Helmet
            htmlAttributes={{
                lang
            }}
            meta={[
                {
                    name: `description`,
                    content: metaDescription
                },
                {
                    property: `title`,
                    content: metaTitle
                },
                {
                    property: `og:title`,
                    content: metaTitle
                },
                {
                    property: `og:description`,
                    content: metaDescription
                },
                {
                    property: `og:type`,
                    content: `website`
                },
                {
                    property: `og:image`,
                    content: metaImage
                },
                {
                    property: `og:url`,
                    content: metaUrl
                },
                {
                    name: `twitter:card`,
                    content: `summary`
                },
                {
                    name: `twitter:creator`,
                    content: metaAuthor
                },
                {
                    name: `twitter:title`,
                    content: metaTitle
                },
                {
                    name: `twitter:description`,
                    content: metaDescription
                }
            ].concat(
                metaKeywords && metaKeywords.length > 0
                    ? {
                          name: `keywords`,
                          content: metaKeywords.join(`, `)
                      }
                    : []
            )}
        />
    )
}

export default SEO

//SEO.defaultProps = {
//lang: `en`,
// meta: [],
//description: ``
//}

//SEO.propTypes = {
// description: PropTypes.string,
// lang: PropTypes.string,
// meta: PropTypes.arrayOf(PropTypes.object),
// title: PropTypes.string.isRequired
//}
